import React, { createContext, useContext, useEffect, useRef } from "react";

const EventBusContext = createContext(null);

export const EventBusProvider = ({ children }) => {
    const listeners = useRef(new Map());

    const subscribe = (event, callback) => {
        if (!listeners.current.has(event)) {
            listeners.current.set(event, new Set());
        }
        listeners.current.get(event).add(callback);

        return () => {
            listeners.current.get(event)?.delete(callback);
            if (listeners.current.get(event)?.size === 0) {
                listeners.current.delete(event);
            }
        };
    };

    const send = (event, payload) => {
        listeners.current.get(event)?.forEach((callback) => callback(payload));
    };

    return (
        <EventBusContext.Provider value={{ subscribe, send }}>
            {children}
        </EventBusContext.Provider>
    );
};

export const useEvent = (event, callback) => {
    const { subscribe } = useContext(EventBusContext);

    useEffect(() => {
        const unsubscribe = subscribe(event, callback);
        return () => unsubscribe(); // Cleanup on unmount
    }, [event, callback, subscribe]);
};

export const useEventBus = () => {
    return useContext(EventBusContext);
};
